import { ITenantRouterUrls } from 'APP/model/tenantRouter/tenantRouterModel.types';
import { Features } from 'APP/packages/features/Features';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export class ProjectUrls {
  public static get servicesUrls(): ITenantRouterUrls {
    const hostConfig = Entities.clientConfig.hostConfig;
    const routerUrls = storage.tenantRouting.get() || ({} as ITenantRouterUrls);

    return {
      bffUrl: hostConfig.bffUrl || routerUrls.bffUrl,
      wsApiUrl: hostConfig.wsApiUrl || routerUrls.wsApiUrl,
      liveKitCallsUrl: hostConfig.liveKitCallsUrl || routerUrls.liveKitCallsUrl,
      unauthorizedUrl: hostConfig.unauthorizedUrl || routerUrls.unauthorizedUrl,
    };
  }

  public static get isCorrectConfig(): boolean {
    return !!ProjectUrls.servicesUrls.bffUrl;
  }

  public static get bffUrl(): string {
    return ProjectUrls.servicesUrls.bffUrl || '';
  }

  public static get unauthorizedUrl(): string {
    return ProjectUrls.servicesUrls.unauthorizedUrl || '';
  }

  public static get bffCallsUrl(): string {
    return ProjectUrls.servicesUrls.bffUrl || '';
  }

  public static get wsApiUrl(): string {
    return ProjectUrls.servicesUrls.wsApiUrl || '';
  }

  public static get wsCallsUrl(): string {
    return ProjectUrls.bffCallsUrl.replace('https', 'wss').replace('http', 'ws') || '';
  }

  public static get liveKitCallsUrl(): string {
    return ProjectUrls.servicesUrls.liveKitCallsUrl || '';
  }

  public static get streamApiUrl(): string {
    return PROJECT_CONFIG.urls.streamApiUrl;
  }

  public static get wsApiUrlDeprecated(): string {
    return PROJECT_CONFIG.urls.wsApiUrlDeprecated;
  }

  public static get publicUrl(): string {
    return PROJECT_CONFIG.urls.publicUrl;
  }

  public static get routerUrl(): string {
    if (Features.isProxyEnabled() && PROJECT_CONFIG.proxyUrls?.routerUrl) {
      return PROJECT_CONFIG.proxyUrls.routerUrl;
    }
    return PROJECT_CONFIG.urls.routerUrl;
  }
}
